import { type TimelineProps as AntdTimelineProps } from "antd";
import { StyledAppTimeline } from "./index.styled";

export type AppTimelineProps = AntdTimelineProps & {
  leftWidth?: number | string;
  rightWidth?: number | string;
};

const AppTimeline: React.FC<AppTimelineProps> = (props) => {
  const { leftWidth = "200px", rightWidth, ...rest } = props;
  return (
    <StyledAppTimeline
      leftWidth={leftWidth}
      rightWidth={rightWidth}
      {...rest}
    />
  );
};

export default AppTimeline;
